import React, { useCallback } from "react";

import ExportListPanel from "fond/export/ExportListPanel";
import { Export, ISGLayerId } from "fond/types";

interface LayerExportProps {
  layerId: ISGLayerId;
  displayName: string;
  title: string;
  hasData?: boolean;
}

const LayerExport: React.FC<LayerExportProps> = ({ layerId, displayName, title, hasData = false }) => {
  const filterExport = useCallback((e: Export) => e.Layers.some((layer) => layer.LayerKey === layerId), [layerId]);

  return (
    <ExportListPanel
      title={title}
      subtitle="Layer exports"
      filterExport={filterExport}
      exportNamePrefix={displayName}
      exportDescription={`Export of ${displayName} layer`}
      createExportOverrides={{ Layers: [layerId] }}
      hasData={hasData}
      noExportsMessage='There are currently no exports for this layer. Click "Create New Export" to get started.'
    />
  );
};

export default LayerExport;
